<div class="flex flex-col pr-2 gap-6">
	<app-mortgage-header
		(goToInstructions)="goToInstructions()"
		[details]="details"
		[mortgage]="_matterMortgage"
		(onViewAll)="viewAll()"
	>
		<div
			logo
			*ngIf="_matterMortgage?.source === MatterMortgageInstructionSource.ASSYST"
			class="w-26"
		>
			<a
				class="hover:underline flex flex-col gap-2 items-center justify-center text-green-600"
				externalNavInterceptor
				target="_blank"
				href="https://unity.doprocess.com/login/home"
			>
				<img
					class="max-w-[100px]"
					src="assets/images/integrations/assyst-logo.svg"
				/>
				<div class="flex gap-2">
					<div>Open</div>
					<app-icon [icon]="ICON.EXTERNAL"></app-icon>
				</div>
			</a>
		</div>
		<div class="max-w-6xl pb-8">
			<div class="flex justify-around">
				<app-checkbox
					type="clear"
					[ngModel]="currentStep >= 0"
					(ngModelChange)="toggleStep(0, $event)"
					>Receive instructions</app-checkbox
				>
				<app-checkbox
					type="clear"
					[ngModel]="currentStep >= 1"
					(ngModelChange)="toggleStep(1, $event)"
					>Submit preliminary report</app-checkbox
				>
				<app-checkbox
					type="clear"
					[ngModel]="currentStep >= 2"
					(ngModelChange)="toggleStep(2, $event)"
					>Submit final report</app-checkbox
				>
			</div>
		</div>
	</app-mortgage-header>

	<app-closer-sync-prompts
		*ngIf="!isVTBMortgage && !lender?.clientId"
		syncFlowType="email"
		(gotoArea)="gotoArea($event)"
	></app-closer-sync-prompts>

	<section>
		<app-mortgage-tabs
			#mortgageTabs
			[tabs]="detailsNavOptions"
			[selectedTab]="selectedDetailNav"
			(tabSelected)="updateSelectedTab($event)"
		/>
		<div [ngSwitch]="selectedDetailNav" class="py-6">
			<app-manual-mortgage-details
				[mortgage]="_matterMortgage"
				*ngSwitchCase="navOptions.MORTGAGE_DETAILS"
			/>
			<app-matter-mortgage-payments
				[mortgage]="_matterMortgage"
				*ngSwitchCase="navOptions.PAYMENT"
			/>
			<app-mortgage-report
				[mortgage]="_matterMortgage"
				*ngSwitchCase="navOptions.REPORT"
			/>
			<app-closer-sync-documents
				(gotoArea)="gotoArea($event)"
				syncFlowType="email"
				*ngSwitchCase="navOptions.DOCUMENTS"
			></app-closer-sync-documents>
		</div>
	</section>
</div>
